module.exports = __webpack_public_path__ + "img/icon55.3c2f152b.png";